import { useEffect } from 'react';

/**
 * Declares the document head for a page.
 *
 * public/index.html carries a single static head (the homepage's), and
 * react-snap prerenders each route from that same document — so a route with a
 * different head has to set it at render time, and every route has to assert
 * its own head rather than assume the static one. Without that, a visitor who
 * lands on the prerendered 404.html and clicks through to the homepage keeps
 * the 404 title for the rest of the session.
 *
 * @param {string} title            document title for this page
 * @param {string|null} canonical   canonical URL, or null for pages that must
 *                                  not advertise one (e.g. the 404 page)
 */
const usePageHead = ({ title, canonical = null }) => {
  useEffect(() => {
    document.title = title;

    const existing = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      existing?.remove();
      return;
    }

    const link = existing ?? document.createElement('link');
    link.rel = 'canonical';
    link.href = canonical;
    if (!existing) document.head.appendChild(link);
  }, [title, canonical]);
};

export default usePageHead;
